module.exports = __webpack_public_path__ + "static/media/Chapter7.902d7708.pdf";